import { render, staticRenderFns } from "./LeftPlatformTable.vue?vue&type=template&id=ebcaff12&scoped=true"
import script from "./LeftPlatformTable.vue?vue&type=script&lang=js"
export * from "./LeftPlatformTable.vue?vue&type=script&lang=js"
import style0 from "./LeftPlatformTable.vue?vue&type=style&index=0&id=ebcaff12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcaff12",
  null
  
)

export default component.exports